import { Home, Plane,FileText,CreditCard,CalendarCheck, MessageSquare,Settings,MoveLeft } from "lucide-react";

const menuItems = [
    { icon: <Home />, label: 'Dashboard', path: '/dashboard' },
    { icon: <Plane />, label: 'Mes Voyages', path: '/mes-voyages' },
    { icon: <FileText />, label: 'Mes Documents', path: '/mes-docuements' },
    { icon: <CreditCard />, label: 'Mes Paiements', path: '/paiements' },
    { icon: <CalendarCheck />, label: 'Mes Réservations', path: '/reservations' },
    { icon: <MessageSquare />, label: 'Messages', path: '/messages' },
    { icon: <Settings />, label: 'Paramètres', path: '/parametres' },
    { icon: <MoveLeft />, label: 'Retourner sur le site', path: '/' },
];

export default menuItems;